<template>
  <th v-if="isHeader">
    <v-checkbox
      @change="toggleAllCheckbox($event)"
      :input-value="isAllItemsInCurrentPageSelected()"
      :indeterminate="isIndeterminate"
      hide-details
    ></v-checkbox>
  </th>
  <td v-else>
    <v-checkbox
      @change="toggleCheckbox(rowData, $event)"
      :input-value="isSelected(rowData)"
      hide-details
    ></v-checkbox>
  </td>
</template>
<script>
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin.vue';

export default {
  name: 'vuetable-material-design-checkbox',
  mixins: [
    VuetableFieldMixin,
  ],
  data() {
    return {
      isIndeterminate: false,
    };
  },
  methods: {
    toggleCheckbox(dataItem, checked) {
      this.vuetable.onCheckboxToggled(checked, this.rowField.name, dataItem);
    },
    toggleAllCheckbox(checked) {
      this.vuetable.onCheckboxToggledAll(checked);
    },
    isSelected(rowData) {
      return this.vuetable.isSelectedRow(rowData[this.vuetable.trackBy]);
    },
    isAllItemsInCurrentPageSelected() {
      if (!this.vuetable.tableData) {
        return null;
      }

      const idColumn = this.vuetable.trackBy;
      const selected = this.vuetable.tableData.filter(
        item => this.vuetable.isSelectedRow(item[idColumn]),
      );

      /* eslint-disable no-else-return */
      if (selected.length <= 0) {
        this.isIndeterminate = false;

        return false;
      } else if (selected.length < this.vuetable.perPage) {
        this.isIndeterminate = true;

        return true;
      }
      /* eslint-enable */

      this.isIndeterminate = false;

      return true;
    },
  },
};
</script>
